import request from '@/utils/request'

// 管理员登录
export function login(data) {
  return request({
    url: '/admin/auth/login',
    method: 'post',
    data
  })
}

// 获取当前管理员信息
export function getProfile() {
  return request({
    url: '/admin/auth/profile',
    method: 'get'
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/admin/auth/password',
    method: 'put',
    data
  })
}

// 登出
export function logout() {
  return request({
    url: '/admin/auth/logout',
    method: 'post'
  })
}

// 创建管理员
export function createAdmin(data) {
  return request({
    url: '/admin/admins',
    method: 'post',
    data
  })
}

// 获取管理员列表
export function getAdminList(params) {
  return request({
    url: '/admin/admins',
    method: 'get',
    params
  })
}

// 更新管理员信息
export function updateAdmin(adminId, data) {
  return request({
    url: `/admin/admins/${adminId}`,
    method: 'put',
    data
  })
}

// 管理员状态管理
export function updateAdminStatus(adminId, data) {
  return request({
    url: `/admin/admins/${adminId}/status`,
    method: 'put',
    data
  })
}

// 重置管理员密码
export function resetAdminPassword(adminId, data) {
  return request({
    url: `/admin/admins/${adminId}/reset-password`,
    method: 'put',
    data
  })
}

// 删除管理员
export function deleteAdmin(adminId) {
  return request({
    url: `/admin/admins/${adminId}`,
    method: 'delete'
  })
}

// ==================== 系统统计接口 ====================

// 获取仪表盘概览数据
export function getDashboard() {
  return request({
    url: '/admin/dashboard',
    method: 'get'
  })
}

// 获取用户统计数据
export function getUserStatistics(params) {
  return request({
    url: '/admin/statistics/users',
    method: 'get',
    params
  })
}

// 获取门店统计数据
export function getStoreStatistics(params) {
  return request({
    url: '/admin/statistics/stores',
    method: 'get',
    params
  })
}

// 获取优惠券统计数据
export function getCouponStatistics(params) {
  return request({
    url: '/admin/statistics/coupons',
    method: 'get',
    params
  })
}

// ==================== 系统管理接口 ====================

// 获取系统配置
export function getSystemConfig() {
  return request({
    url: '/admin/system/config',
    method: 'get'
  })
}

// 获取操作日志
export function getSystemLogs(params) {
  return request({
    url: '/admin/system/logs',
    method: 'get',
    params
  })
}

// 清理过期数据
export function cleanupExpiredData(data) {
  return request({
    url: '/admin/system/cleanup',
    method: 'post',
    data
  })
} 